import React from 'react'
import { history } from './../../helpers/history'
import { isMobile } from './../../helpers/window.helper'
import {
	LineTitleWrapper,
	LineTitleLeft,
	LineTitleRight,
	StyledContainer,
} from './styled-components.component'

const LineTitle = ({ children }) => (
	<LineTitleWrapper>
		<LineTitleLeft />
		{children}
		<LineTitleRight />
	</LineTitleWrapper>
)

export default class StoreProductOverview extends React.Component {
	render() {
		const {
			name,
			points,
			pointsForSubscribers,
			src,
			id,
			priceNotMember,
			priceForMember,
		} = this.props

		if (priceNotMember == null && priceForMember == null) {
			return (
				<StyledContainer
					onClick={() => history.push(`/loja/produto/${id}`)}>
					<img src={src} alt={name} />
					<p className={`name ${isMobile() ? 'center' : ''}`}>{name}</p>
					{isMobile() ? null : <hr />}
					<p className={`no-margin ${isMobile() ? 'center' : ''}`}>
						<span className={'startingAt'}>A partir de</span>
						<br />
						<span className={'blue points'}>
							{points.toLocaleString('pt-BR')} pontos
						</span>
					</p>
					{/* <LineTitle>
						<span className={'light-orange bold'}>Clube Muviflex</span>
					</LineTitle>
					<p className={`no-margin ${isMobile() ? 'center' : ''}`}>
						<span className={'startingAt'}>A partir de</span>
						<br />
						<span className={'blue points'}>
							{points.toLocaleString('pt-BR')} pontos
						</span>
					</p> */}
				</StyledContainer>
			)
		} else {
			return (
				<StyledContainer
					onClick={() => history.push(`/loja/produto/${id}`)}>
					<img src={src} alt={name} />
					<p className={`name ${isMobile() ? 'center' : ''}`}>{name}</p>
					{isMobile() ? null : <hr />}
					<p className={`no-margin ${isMobile() ? 'center' : ''}`}>
						<span className={'startingAt'}>A partir de</span>
						<br />
						<span className={'blue points'}>
							{priceNotMember.$toReais()} 
						</span>
					</p>
					{/* <LineTitle>
						<span className={'light-orange bold'}>Clube Muviflex</span>
					</LineTitle>
					<p className={`no-margin ${isMobile() ? 'center' : ''}`}>
						<span className={'startingAt'}>A partir de</span>
						<br />
						<span className={'blue points'}>
							{priceForMember.$toReais()}
						</span>
					</p> */}
				</StyledContainer>
			)
		}
	}
}
